import React from 'react';
import toast from 'react-hot-toast';
import { Copy } from 'lucide-react';

const CopyButton = ({ text, label = '', className = '' }) => {
  const handleCopy = (e) => {
    e.stopPropagation();
    if (!text) return;

    try {
      navigator.clipboard.writeText(text);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }

    toast.success(label ? `${label} copied to clipboard!` : `Copied to clipboard: ${text}`, {
      id: `copy-${text}`,
    });
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={label ? `Copy ${label}` : 'Copy to clipboard'}
      className={`inline-flex items-center space-x-1 px-1.5 py-0.5 rounded-md bg-[#1A1A1E] hover:bg-[#27272A] border border-[#27272A] text-[#9CA3AF] hover:text-[#FFFFFF] transition-all text-[10px] ${className}`}
    >
      <Copy className="w-3 h-3 shrink-0" />
      {label && <span className="text-[10px]">{label}</span>}
    </button>
  );
};

export default CopyButton;
